'use client';

import { useBalanceRefresh } from '@/hooks/useBalanceRefresh';

export default function BalanceRefreshWrapper({ children }: { children: React.ReactNode }) {
  useBalanceRefresh();
  return <>{children}</>;
}
